import { httpPost, httpPut, httpGet, httpDel } from '@/tool/request/index';
import type { TrainingFormData, TrainingDetailData } from '@/pages/training/types';

// API提交数据类型
interface TrainingSubmitData {
  id?: number;
  topic: string;
  trainingTime: string;
  participants: string; // 逗号分隔的字符串
  remark: string;
  uploadFiles: string[];
}

// 新增培训记录
export async function trainingSave(data: TrainingSubmitData) {
  return await httpPost<API.RootResponse<any>>(`/training/`)({
    data,
  });
}

// 修改培训记录
export async function trainingUpdate(data: TrainingSubmitData) {
  return await httpPut<API.RootResponse<any>>(`/training/${data.id}`)({
    data,
  });
}

// 获取培训详情
export async function trainingDetail(id: string) {
  return await httpGet<API.RootResponse<TrainingDetailData>>(`/training/${id}`)();
}

// 删除培训记录
export async function trainingDelete(id: string) {
  return await httpDel<API.RootResponse<any>>(`/training/${id}`)();
}



